import { useCallback, useEffect, useRef, useState } from "react";
import { scrollPageToTop } from "../../utils/scrollToTop";

export function useServerPagination(initialPageSize = 25) {
  const [page, setPageState] = useState(1);
  const [pageSize, setPageSizeState] = useState(initialPageSize);
  const firstScrollRender = useRef(true);

  useEffect(() => {
    if (firstScrollRender.current) {
      firstScrollRender.current = false;
      return;
    }

    window.requestAnimationFrame(() => scrollPageToTop({ behavior: "smooth" }));
  }, [page, pageSize]);

  const setPage = useCallback((value) => {
    setPageState((currentPage) => {
      const nextPage =
        typeof value === "function" ? value(currentPage) : Number(value);

      return Math.max(1, nextPage || 1);
    });
  }, []);

  const setPageSize = useCallback(
    (value) => {
      const nextSize = Number(value) || initialPageSize;

      setPageSizeState(Math.max(1, nextSize));
      setPageState(1);
    },
    [initialPageSize]
  );

  const resetPage = useCallback(() => {
    setPageState(1);
  }, []);

  return {
    page,
    pageSize,
    setPage,
    setPageSize,
    resetPage,
  };
}
